export const initResisableTable_v2 = function(pageId){

	if(!window.globalData_v2) return;
	var tableHead = document.getElementById('headsTable#' + pageId);
	var tableBody = document.getElementById('bodyTable#' + pageId);
	resizableGrid_v2(tableHead,tableBody,pageId);
}

// var allRows;
// var globalCurOffSetWidth;
// var globalCurBelowOffSetWidth;
// var globalNxtOffSetWidth;
// var globalNxtBelowOffSetWidth;
// var globalCurColId;
window.globalResizedElements_v2=[];

function resizableGrid_v2(tableHead,tableBody,pageId) {
	var firstRow = tableHead.getElementsByTagName('tr')[0];
	var cols = firstRow ? firstRow.children : undefined;

 	if (!cols) return;

 	tableHead.style.overflow = 'hidden';

 	var tableHeight = tableBody.offsetHeight;

	for (var i=0;i<cols.length;i++){
		var div = createDiv(tableHeight);
		cols[i].appendChild(div);
		cols[i].style.position = 'relative';
		setListeners(div);
	}

	var firstRowOfBody = tableBody.getElementsByTagName('tr')[0];
	var colsBody = firstRowOfBody ? firstRowOfBody.children : undefined;
 	//Add div to all rows

	for(var k=0;k<colsBody.length;k++){

		  var div = createDiv("5");
		  colsBody[k].appendChild(div);
		  colsBody[k].style.position = 'relative';
	}

	function setListeners(div){

		var pageX,curCol,nxtCol,curColWidth,nxtColWidth,prevColWidth,belowColumn,belowNxtColumn;

	  	div.addEventListener('mousedown', function (e) {

		   	curCol = e.target.parentElement;

		   	if(curCol){

				belowColumn = document.getElementById("b"+curCol.id);
			}

	   		nxtCol = curCol.nextElementSibling;

	   		if(nxtCol){

				belowNxtColumn = document.getElementById("b"+nxtCol.id);
			}

	   		pageX = e.pageX;
	   		var padding = paddingDiff(curCol);

	   		curColWidth = curCol.offsetWidth - padding;
	   		if (nxtCol){
								nxtColWidth = nxtCol.offsetWidth - padding;
						}
	  	});

		// div.addEventListener('mouseover', function (e) {
		// 	e.target.style.borderRight = '1px solid #dbdbdb';
		// })

		// div.addEventListener('mouseout', function (e) {
		// 	e.target.style.borderRight = '1px solid #dbdbdb';
		// })

		window.addEventListener('mousemove', function (e) {
			if (curCol) {

				var diffX = e.pageX - pageX;
				curCol.style.width = (curColWidth + diffX)+'px';
				belowColumn.style.width = curCol.style.width;
				let colWidth = e.target.style.width;
				let colName = e.target.innerText;
				if(colName != ''){
					recordColWidth (colName,colWidth);
				}

				if (nxtCol){
				 	nxtCol.style.width = (nxtColWidth - (diffX))+'px';
					belowNxtColumn.style.width = nxtCol.style.width;

					let nextColwidth = nxtCol.style.width;
					colName = nxtCol.innerText;

					colWidth = nextColwidth;

					if(colName != ''){
						recordColWidth (colName,colWidth);
					}
				}
			}
		});

	  	window.addEventListener('mouseup', function (e) {

		   	 curCol = undefined;
	  	});
	 }

	 function recordColWidth (name,width){
		let added = false; //to check column present

		if(window.globalResizedElements_v2.length == 0){ //saving first time
			if(name != '' && width != ''){
				window.globalResizedElements_v2[0] = 'nothing';
				window.globalResizedElements_v2[1]= name;
				window.globalResizedElements_v2[2]= width;
				added = true;
			}
		}
		if(window.globalResizedElements_v2.length > 0){  //saving more than one column
			if(name != '' && width != ''){
				for(let i = 1; i < window.globalResizedElements_v2.length; i++){
					if( window.globalResizedElements_v2[i] == name){
						if(window.globalResizedElements_v2[i + 1] != width){
							window.globalResizedElements_v2[i + 1] = width;
							added = true;
						}
					}
				}
				if(added == false){   //add new col at end of array
					var lastIndex = window.globalResizedElements_v2.length;
					window.globalResizedElements_v2[lastIndex] = name;
					window.globalResizedElements_v2[lastIndex + 1] = width;
				}
			}
		}
		// console.log(window.globalResizedElements_v2)
	 }

	function createDiv(height){

	  	var div = document.createElement('div');
	  	div.style.top = 0;
	  	div.style.right = 0;
	  	div.style.width = '5px';
	  	div.style.position = 'absolute';
	  	// div.style.cursor = 'col-resize';
		div.style.userSelect = 'none';
	  	div.style.height = height + 'px';
	 	return div;
	}

	function paddingDiff(col){

	  	if (getStyleVal(col,'box-sizing') == 'border-box'){
	  	 	return 0;
	  	}

	  	var padLeft = getStyleVal(col,'padding-left');
	  	var padRight = getStyleVal(col,'padding-right');
	  	return (parseInt(padLeft) + parseInt(padRight));

	}

	function getStyleVal(elm,css){
  		return (window.getComputedStyle(elm, null).getPropertyValue(css))
 	}
}